export default "__VITE_ASSET__431f16ce__$_?component__"